import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import DialogTransition from 'components/DialogTransition';
import CloseIcon from '@material-ui/icons/Close';
import _find from 'lodash/find';
import Colors from 'utils/colors';

const styles = theme => ({
  close: {
    position: 'absolute',
    top: 0,
    right: 5,
    zIndex: 10,
    cursor: 'pointer',
  },
  closeIcon: {
    fontSize: 30,
  },
  contentContainer: {
    marginTop: 35,
  },
  subList: {
    margin: '0 5%',
  },
  link: {
    margin: '5px 5%',
    color: Colors.blue,
    cursor: 'pointer',
  },
  activeMenu: {
    backgroundColor: theme.palette.primary.secondary,
  },
});

function CorporateDialogMenu(props) {
  const { classes, open, handleClose, menuItems, menuList, redirect } = props;
  const pathName = window.location.pathname;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={DialogTransition}
    >
      <IconButton
        color="inherit"
        onClick={handleClose}
        aria-label="Close"
        className={classes.close}
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
      <List className={classes.contentContainer}>
        {!_isEmpty(menuItems) &&
          !_isEmpty(menuList) &&
          menuList.map(item => {
            const data = _find(menuItems, { slug: item });
            const isActive = pathName.includes(data.name.toLowerCase());
            return (
              <React.Fragment key={data.slug}>
                <ListItem
                  button
                  onClick={() => redirect(data.slug)}
                  className={isActive ? classes.activeMenu : ''}
                >
                  <ListItemText primary={data.name} />
                </ListItem>
                <Divider />
              </React.Fragment>
            );
          })}
        <ListItem button onClick={() => redirect()}>
          <ListItemText primary="To CredibleMind" />
        </ListItem>
      </List>
    </Dialog>
  );
}

CorporateDialogMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  menuItems: PropTypes.array,
  menuList: PropTypes.array,
  redirect: PropTypes.func,
};

export default withStyles(styles)(CorporateDialogMenu);
